/**
 * @file 랜덤 문자열 (randomstring 패키지 대체)
 * @description randomstring 패키지는 내부에서 Node crypto를 불러서, 브라우저 빌드에 crypto 폴리필 전체
 *              (crypto-browserify, elliptic, bn.js, browserify-* 등)가 들어가고 reducer를 통해 첫 화면에 실렸다
 *              프로젝트는 generate(길이)만 쓰므로 같은 결과를 내는 작은 구현으로 바꾼다
 *              - 문자: 숫자 + 소문자 + 대문자 (randomstring alphanumeric과 같은 순서)
 *              - 뽑기: 브라우저 crypto.getRandomValues + 치우침 없는 거절 샘플링 (randomstring과 같은 방식)
 *              - 길이를 안 주면 32 (randomstring 기본값)
 *              사용법은 그대로: import randomString from 'ts-utils/randomstring'; randomString.generate(7)
 * @author 백재인
 * @date 2026-09-30
 */

const CHARS = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
const MAX_BYTE = 256 - (256 % CHARS.length)

const randomBytes = (length: number) => {
    const bytes = new Uint8Array(length)
    const crypto = typeof window !== 'undefined' ? window.crypto : undefined

    if (crypto && crypto.getRandomValues) crypto.getRandomValues(bytes)
    else for (let i = 0; i < length; i++) bytes[i] = Math.floor(Math.random() * 256)

    return bytes
}

function generate(length: number = 32): string {
    let rest = length
    let result = ''

    while (rest > 0) {
        const bytes = randomBytes(Math.ceil(rest * 256 / MAX_BYTE))

        for (let i = 0; i < bytes.length && rest > 0; i++) {
            if (bytes[i] < MAX_BYTE) {
                result += CHARS.charAt(bytes[i] % CHARS.length)
                rest--
            }
        }
    }

    return result
}

const randomstring = { generate }

export default randomstring
